













































































































import { Component, Vue } from "vue-property-decorator";
import "@/styles/MCQ.scss";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";
import AuthService from "../services/auth-service";
import Questions from "../components/Questions.vue";
import * as franc from "franc";
import moment from 'moment';
import VueApexCharts from "vue-apexcharts";
import Loader from "../views/Loader.vue";

import
BreadCrumb
  from
  "./breadCrumb.vue"
  ;


@Component({
  components: {
    apexchart: VueApexCharts,
    question: Questions,
    BreadCrumb: BreadCrumb,
    "loader": Loader,
  },
     props: ["quizId", "moduleId", "trainingId", "contentType"],

})
export default class TraningQuiz extends Vue {
  private service = new GeneralService();
  private questions: QuestionE[] = [];
  private questionComponentKey = 0;
  private answers: ProvidedAnswers[] = [];
  private sheetAnswerData: any = [];
  private isQuestion = false;
  private attempted: number = 0;
  private topicId: string = "";
  private level_id;
  private checkTopic = false;
  private auth = new AuthService();
  private mcqlimit = 10000;
  private chapterlimit = 10000;
  private topiclimit = 10000;
  private modalShow = false;
  private quizData: TrainingQuiz | null = null;
  private selectedAnswers: { [questionIndex: number]: string } = {};
  private attemptedCount: number = 0;
  private unattemptedCount: number = 0;
  private obtainedMarks: number = 0;
  private totalMarks: number = 0;
  private obtainedPercentage: number = 0;
  private isPassed: boolean | null = null;
  private isGraded: boolean = false;
  private emptyAnswers: any = [];
  private isPastPaper = false;
  private chapterIds: any = [];
  private checkedChapters: any = [];
  private allChapters: any = [];
  private limitQuestions = 1;
  private shouldDisplay = false;
  private startTime:any = moment();
  private endTime:any = moment();
  private timeTaken:any = -1;
  private secondsTaken: any = 0;
  private shouldDisable = false;
  private correctAnswers = 0;
  private incorrectAnswers = 0;
  private isFinished = false;
  private series:any = []
  private isReview = false;
  private isLoading = false;
  public loading = false;
  public val: any = '';
  boardId: any = '';
  classId: any = '';
  dataFound: boolean = false;
  IsArvo: boolean = false;
  public SloBased:boolean=false;
  public ShowNote:boolean=false;
  IsError : boolean = false;
  IsApiError : boolean = false;
  errMsg : any = '';
public quizId: string; // Prop for quizId
public moduleId: string; 
public trainingId:string;
public contentType: string;
  listStart: number;
  isretake:boolean=false;
    actionlist: GActivity[];
// Prop for moduleId

  // Chart configuration for results
  get chartOptions() {
    return {
      labels: ['Correct', 'Incorrect', 'Unattempted'],
      colors: ['#4caf50', '#f44336', '#ffeb3b'],
      legend: {
        show: false,
      },
      tooltip: {
        enabled: true,
        custom: ({ series, seriesIndex, dataPointIndex, w }) => {
          const labels = w.config.labels || ['Correct', 'Incorrect', 'Unattempted'];
          const value = series[seriesIndex];
          const label = labels[seriesIndex];
          
          // console.log('Tooltip data:', { seriesIndex, value, label, series, labels }); // Debug log
          
          return `<div style="background: rgba(0, 0, 0, 0.8); color: white; padding: 8px 12px; border-radius: 4px; font-size: 14px; font-weight: 500; border: none; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
                    <span>${label}: ${value}</span>
                  </div>`;
        }
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: false
            }
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: (val: number) => {
          return Math.round(val) + '%';
        }
      }
    };
  }

  get chartSeries() {
    if (!this.quizData) return [0, 0, 0];
    
    const total = this.quizData.totalQuestions;
    const correct = this.correctAnswers;
    const incorrect = this.incorrectAnswers;
    const unattempted = total - this.attemptedCount;
    
    return [correct, incorrect, unattempted];
  }

get allQuestionsAttempted() {
  if (!this.quizData) return false;

  return Object.keys(this.selectedAnswers).length === this.quizData.totalQuestions;
}

  breadcrumbItems: Array<{ text: string; link: any; active?: boolean }> = [];
  private totalQUestions: any ;

  handleClick(event, type) {
    
    const itemText = event.target.innerText;
    // if (itemText === "Chapters") {
    this.updateBreadcrumbs(itemText, type);
    // }
  }
  RetakeTest() {
    debugger
    this.isretake = true;
    this.listStart = 1;
    this.resetQuiz();
    var key = this.moduleId + "?" + this.quizId;
    this.val = this.moduleId + '?' + this.quizId;
    this.service
      .getTrainingQuiz(this.val)
      .then((result) => {

        const key = this.contentType + '?' + this.quizId + '?' + this.trainingId + '?' + this.moduleId;
        this.service.trainiguseractionlog(key).then((result) => {
          this.actionlist = result;
        });
        this.loading = false;
        this.quizData = result.data;
        this.totalQUestions = this.quizData?.totalQuestions;
        if (this.quizData && this.quizData.trainingQuizContent && this.quizData.trainingQuizContent.length > 0) {
          this.dataFound = true;
          this.startTime = moment();
          this.selectedAnswers = {};
          this.attemptedCount = 0;
        } else {
          this.dataFound = false;
        }
      })
      .catch((err) => {
        this.IsApiError = true;
        this.errMsg = "Server Error";
        console.error(`Error: ${err.message}`);
      });
    // Re-fetch quiz data and reset state
  }
  updateBreadcrumbs(newTopic, type) {
    
    const exists = this.breadcrumbItems.some(
      item => item.text === newTopic
    );
    if (!exists) {
      this.breadcrumbItems.forEach(item => {
        item.active = false;
      });
      this.breadcrumbItems.push({
        text: newTopic,
        link: '#',
        active: true,
      });

    }
    else {
      //  this.reset(type)
      this.breadcrumbItems.pop();
      if (this.breadcrumbItems.length > 0) {
        this.breadcrumbItems[this.breadcrumbItems.length - 1].active = true;
      }
      this.isQuestion = false;
       this.isFinished=false

    }

  }
get paginatedQuestions() {
  if (!this.quizData) return [];

  const start = (this.listStart - 1) * 10;
  const end = start + 10;

  return this.quizData.trainingQuizContent.slice(start, end);
}

   selectAnswer(questionIndex: number, optionName: string): void {
    
    if (this.selectedAnswers[questionIndex] !== undefined && this.selectedAnswers[questionIndex] !== null) {
      return; // already answered → do nothing
    }
    this.attemptedCount++;
    // Use Vue.set to ensure reactivity
    Vue.set(this.selectedAnswers, questionIndex, optionName);
  }

   finishTest(): void {
    
    this.isFinished = true;
    this.endTime = moment();

    this.timeTaken = this.endTime.diff(this.startTime, 'minutes', true);

    if (this.timeTaken > 0){
      this.secondsTaken = Math.floor((this.timeTaken % 1) * 60)
      this.timeTaken = Math.floor(this.timeTaken)
    }


    // Prepare submission payload
    if (this.quizData) {
      const moduleName = JSON.parse(localStorage.getItem("isToggled")!) ? "El" : "Academic Calender";
      
      const submissionPayload = {
        organization: 'HADAF',
         module: 'El', 
        device: "Web",
        email: this.auth.session.userName,
        quizId: this.quizData.id,
        trainingId: this.trainingId,
        trainingModuleId: this.moduleId,
        audience: "STUDENT",
        isRetake: false,
        isTimeUp: false,
        
        detail: this.quizData.trainingQuizContent.map((question, index) => {
          const selectedOptionName = this.selectedAnswers[index];
          const selectedOption = selectedOptionName ? 
            question.options.find(opt => opt.optionName === selectedOptionName) : null;
          
          return {
            contentId: question.contentId,
            contentType: "MCQs",
            selectedOption: selectedOption ? selectedOption.optionName : null,
            isAttempted: !!selectedOptionName
          };
        })
      };
      // Submit quiz to API using the correct training quiz method
      this.service.submitTrainingQuiz(submissionPayload)
        .then((response: any) => {
          if (response && response.data) {
            // Use API response data for chart
            this.correctAnswers = response.data.correct || 0;
            this.incorrectAnswers = response.data.inCorrect || 0;
            this.unattemptedCount = response.data.unattempted || 0;
            this.obtainedMarks = response.data.obtainedMarks || 0;
            this.totalMarks = response.data.totalMarks || 0;
            this.obtainedPercentage = response.data.obtainedPercentage || 0;
            this.isPassed = response.data.isPassed;
            this.isGraded = response.data.isGraded;
            
            // Update series for the pie chart with API data
            this.series = [this.correctAnswers, this.incorrectAnswers, this.unattemptedCount];
            
            console.log('Chart data updated:', {
              correct: this.correctAnswers,
              incorrect: this.incorrectAnswers,
              unattempted: this.unattemptedCount,
              obtainedMarks: this.obtainedMarks,
              totalMarks: this.totalMarks,
              percentage: this.obtainedPercentage
            });
          }
        })
        .catch((error) => {
          console.error('Quiz submission failed:', error);
          // Fallback to local calculation if API fails
          this.calculateLocalResults();
        });
    }
  }
onChange() {
    window.scrollTo(0, 0);
  }

  getTotalRows(): number {
    if (this.quizData && this.quizData.trainingQuizContent && Array.isArray(this.quizData.trainingQuizContent)) {
      return this.quizData.trainingQuizContent.length;
    }
    return 0;
  }

  private calculateLocalResults(): void {
    // Fallback method for local calculation
    let correctCount = 0;
    let incorrectCount = 0;
    
    if (this.quizData) {
      this.quizData.trainingQuizContent.forEach((question, index) => {
        const selectedOptionName = this.selectedAnswers[index];
        if (selectedOptionName) {
          const selectedOption = question.options.find(opt => opt.optionName === selectedOptionName);
          if (selectedOption && selectedOption.isCorrect) {
            correctCount++;
          } else {
            incorrectCount++;
          }
        }
      });
    }

    this.correctAnswers = correctCount;
    this.incorrectAnswers = incorrectCount;
    this.unattemptedCount = (this.quizData?.totalQuestions || 0) - this.attemptedCount;
    
    // Update series for the pie chart
    this.series = [this.correctAnswers, this.incorrectAnswers, this.unattemptedCount];
  }

  resetQuiz() {
  this.isFinished = false;
  this.selectedAnswers = {};
  this.attemptedCount = 0;
  this.listStart = 1;
}

  beforeDestroy() {
  this.resetQuiz();
}
  data() {
    return {
      breadcrumbItems: [

      ],
      
      fields: [
        // A virtual column that doesn't exist in items
        "index",
        // A column that needs custom formatting
        { key: "fullName", label: "Chapter Name" },
      ],
      filter: null,
       listStart: 1,
        shouldShow: function (index, value) {
          if ((this.listStart - 1) * 10 <= index && this.listStart * 10 > index) {
            return true;
          } else {
            return false;
          }

        }
    };
  }

  created() {
    this.loading = true;
    this.isFinished=false;
    // Initialize quiz data
    this.selectedAnswers = {};
    this.attemptedCount = 0;
    const programSelectString = localStorage[config.programSelect];
    const ClassId=localStorage.getItem("clid");
    const programSelectData = JSON.parse(programSelectString);
    //  this.boardId = programSelectData.board;
    this.boardId = programSelectData.board.endsWith('s')
      ? programSelectData.board.slice(0, -1)
      : programSelectData.board;
    this.classId = programSelectData.part.replace(/\s+/g, '');
    

    this.level_id = this.$store.state.selectSubject;
  
    if (
      this.$store.state.selectSubject == "" ||
      this.$store.state.selectSubject == undefined ||
      this.$store.state.selectSubject == "null"
    ) {
      router.push("trainingcourses");
    }

    this.breadcrumbItems.push({
      text: "Training Courses",
      link: "selectEL",
      active: false
    });
    this.breadcrumbItems.push({
      text: this.$store.state.selectSubjectName,
      link: "trainingmodules",
      active: true
    });
    var key = this.moduleId + "?" + this.quizId;
    this.val = this.moduleId + '?' + this.quizId;
    this.service
      .getTrainingQuiz(this.val)
      .then((result) => {
   
        this.loading = false;
        this.quizData = result.data;
        
         this.totalQUestions = this.quizData?.totalQuestions;
        if (this.quizData && this.quizData.trainingQuizContent && this.quizData.trainingQuizContent.length > 0) {
          this.dataFound = true;
          this.startTime = moment();
          
          // Initialize answers tracking
          this.selectedAnswers = {};
          this.attemptedCount = 0;
        } else {
          this.dataFound = false;
        }
      })
      .catch((err) => {
        this.IsApiError = true;
        this.errMsg = "Server Error";
        console.error(`Error: ${err.message}`);
      });
  }
}

interface ProvidedAnswers {
  questionId: string;
  answer: boolean;
  answerId: string;
}

interface TrainingQuiz {
  id: string;
  title: string;
  description: string;
  instruction: string;
  isGraded: boolean;
  isTimeBound: boolean;
  passingPercentage: number;
  totalQuestions: number;
  trainingQuizContent: TrainingQuizQuestion[];
}

interface TrainingQuizQuestion {
  contentId: string;
  contentStatement: string;
  contentType: string;
  contentTypeCode: string | null;
  contentTypeId: string;
  language: string;
  languageId: string;
  questionMarks: number;
  options: QuizOption[];
}

interface QuizOption {
  mcqId: string;
  optionName: string;
  optionValue?: string;
  isCorrect: boolean;
}
